// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"9c2dbef9","295":"ef738295","349":"6ea2d400","403":"bef30064","453":"4d4695ea","511":"2a3c84c9","516":"42ce91f4","600":"a32915b2","655":"562514fe","791":"74c05014","813":"7cbeb9dc","852":"dafa3f1b","963":"e23e2973"}[chunkId] + ".chunk.js";
};